import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setting-component" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  class: "form-label",
  for: "once-label"
}
const _hoisted_4 = { class: "form-group form-group-near" }
const _hoisted_5 = {
  class: "form-label",
  for: "once-message"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  class: "form-label",
  for: "twice-label"
}
const _hoisted_8 = { class: "form-group form-group-near" }
const _hoisted_9 = {
  class: "form-label",
  for: "twice-message"
}
const _hoisted_10 = { class: "form-group stage-b-item" }
const _hoisted_11 = {
  class: "form-label",
  for: "next-lot-label"
}
const _hoisted_12 = { class: "form-group form-group-near stage-b-item" }
const _hoisted_13 = {
  class: "form-label",
  for: "next-lot-message"
}
const _hoisted_14 = { class: "form-group stage-b-item" }
const _hoisted_15 = {
  class: "form-label",
  for: "pass-lot-message"
}
const _hoisted_16 = { class: "action-block" }

import { ref, watch } from "vue";

  import CustomInput from "@/components/_partials/widget/CustomInput.vue";
  import { trans } from "@/utils/trans";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import apiClient from "@/services/api";
  import { useToast } from "primevue/usetoast";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import simplebar from "simplebar-vue";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Labels',
  setup(__props) {

  const toast = useToast();
  const auctionStore = useAuctionStore();

  const settings = ref({
    once_label: auctionStore.liveSettings?.once_label,
    once_message: auctionStore.liveSettings?.once_message,
    twice_label: auctionStore.liveSettings?.twice_label,
    twice_message: auctionStore.liveSettings?.twice_message,
    next_lot_label: auctionStore.liveSettings?.next_lot_label,
    next_lot_message: auctionStore.liveSettings?.next_lot_message,
    pass_lot_message: auctionStore.liveSettings?.pass_lot_message
  });

  const scrollComponent = ref<typeof simplebar>(null);

  watch(
    () => auctionStore.liveSettings,
    (nv) => {
      settings.value.once_label = nv?.once_label;
      settings.value.once_message = nv?.once_message;
      settings.value.twice_label = nv?.twice_label;
      settings.value.twice_message = nv?.twice_message;
      settings.value.next_lot_label = nv?.next_lot_label;
      settings.value.next_lot_message = nv?.next_lot_message;
      settings.value.pass_lot_message = nv?.pass_lot_message;
    },
    { deep: true }
  );

  const initScroll = (scroll) => {
    scrollComponent.value = scroll;
  };

  const save = () => {
    apiClient
      .put(auctionStore.routes["auctions.update_live_settings"], settings.value)
      .then((response) => {
        if (response.data.status && response.data.settings) {
          auctionStore.$patch(response.data.settings);
        } else {
          console.log(response);
        }
        toast.add({
          severity: response.data.status ? "success" : "error",
          summary: trans("live.toast." + (response.data.status ? "success" : "error")),
          detail: response.data.message || trans("live.toast.unknown_error"),
          life: 6000
        });
      })
      .catch((error) => {
        console.log(error);
        const errors = error.response.data.errors;
        Object.keys(errors).forEach((key) => {
          errors[key].forEach((error: string) => {
            toast.add({
              severity: "error",
              summary: trans("live.toast.error"),
              detail: error || trans("live.toast.unknown_error"),
              life: 6000
            });
          });
        });
      });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomScrollbar, {
      class: "custom-scrollbar controller-scrollbar",
      onScrollerComponent: initScroll
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(trans)("live.tabs.settings.labels_tab.labels.once_label")), 1),
          _createVNode(CustomInput, {
            modelValue: settings.value.once_label,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((settings.value.once_label) = $event)),
            "input-id": "once-label",
            type: "text",
            "with-clear": "",
            "input-class": "input"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(trans)("live.tabs.settings.labels_tab.labels.once_message")), 1),
          _createVNode(CustomInput, {
            modelValue: settings.value.once_message,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settings.value.once_message) = $event)),
            "input-id": "once-message",
            type: "text",
            "with-clear": "",
            "input-class": "input"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(trans)("live.tabs.settings.labels_tab.labels.twice_label")), 1),
          _createVNode(CustomInput, {
            modelValue: settings.value.twice_label,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((settings.value.twice_label) = $event)),
            "input-id": "twice-label",
            type: "text",
            "with-clear": "",
            "input-class": "input"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(trans)("live.tabs.settings.labels_tab.labels.twice_message")), 1),
          _createVNode(CustomInput, {
            modelValue: settings.value.twice_message,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((settings.value.twice_message) = $event)),
            "input-id": "twice-message",
            type: "text",
            "with-clear": "",
            "input-class": "input"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(trans)("live.tabs.settings.labels_tab.labels.next_lot_label")), 1),
          _createVNode(CustomInput, {
            modelValue: settings.value.next_lot_label,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((settings.value.next_lot_label) = $event)),
            "input-id": "next-lot-label",
            type: "text",
            "with-clear": "",
            "input-class": "input"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(trans)("live.tabs.settings.labels_tab.labels.next_lot_message")), 1),
          _createVNode(CustomInput, {
            modelValue: settings.value.next_lot_message,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((settings.value.next_lot_message) = $event)),
            "input-id": "next-lot-message",
            type: "text",
            "with-clear": "",
            "input-class": "input"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(trans)("live.tabs.settings.labels_tab.labels.pass_lot_message")), 1),
          _createVNode(CustomInput, {
            modelValue: settings.value.pass_lot_message,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((settings.value.pass_lot_message) = $event)),
            "input-id": "pass-lot-message",
            type: "text",
            "with-clear": "",
            "input-class": "input"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        class: "btn btn-blue action",
        onClick: save
      }, _toDisplayString(_unref(trans)("live.tabs.settings.labels_tab.actions.save")), 1)
    ])
  ]))
}
}

})